import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

export const SuperAdminContext = createContext(null);

export function SuperAdminContextProvider({ children }) {
  const [superAdmin, setSuperAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = () => {
    setLoading(true);
    axios.get("https://api.komorotel.com/api/superadmin/me", { withCredentials: true })
      .then(r => setSuperAdmin(r.data))
      .catch(() => setSuperAdmin(null))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchMe(); }, []);

  return (
    <SuperAdminContext.Provider value={{ superAdmin, setSuperAdmin, loading, refetch: fetchMe }}>
      {children}
    </SuperAdminContext.Provider>
  );
}

export const useSuperAdmin = () => useContext(SuperAdminContext);
